import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js'; 
import {initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import CashoutService from "../../../services/cashout-service.js";
import { FormField, SelectField } from './../../common/helper/formFields';

const AddBatch = () => { 
  const [loading, setLoading] = useState(false);
  const [formData,setFormData] = useState({amount:100000});
  const userData = useSelector(state => state.authReducer);
  const [errors, setErrors] = useState({ ...initialErrors });
  const navigate = useNavigate();
  const { id } = useParams();
  const [paymentMethods,setPaymentMethods] = useState([]);
  const [batchResponse,setBatchResponse] = useState();
  const [role,setUserRole] = useState();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  }
  const validateField = (fieldName, value) => {
    let errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const addNewBatch = (e) => {
    console.log('c')
    e.preventDefault();
    let requiredFields = ['amount'];
    if (!validateFields(requiredFields, formData)) {
        return
      } 
      let request = {
        max_amount: formData.amount,
        payment_method_type_id: formData.payment_method
       
      }
      setLoading(true)
      CashoutService.createBatch(request)
          .then(response => {
            console.log(response)
            setLoading(false);
            toast.success(MESSAGES.BATCH_CREATED);
            setBatchResponse(response.data.data)
            //navigate('/cashouts')
           
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
  const clearAmount = () => {
  
    setFormData(prev => ({
      ...prev,
      amount:''
    }))
  }
  const getSubPayments = (e) => {
    setLoading(true);
    CashoutService.getPaymentMethods(id)
      .then(response => {
        let data = response.data.data
        const arr = [];
        for(var i=0; i<data.length; i++) {
        
            arr.push({
              label: data[i].value,
              value: data[i].key,
            })
        }
        const impsOption = arr.find(option =>
          option.label.toLowerCase().includes("imps")
        );
       
        setPaymentMethods(arr);
        setFormData(prev => ({
          ...prev,
          payment_method: impsOption ? impsOption.value : "null", // Default to "null" if IMPS is not found
        }));
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };

  const downloadBatchFile = () => {
    setLoading(true)
    CashoutService.downloadBatchfile(batchResponse.batch_id)
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'batch.csv'); // Specify the file name here
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          link.parentNode.removeChild(link);
          toast.success(MESSAGES.FILE_UPLOADED)
          setLoading(false);
         
        })
        .catch(error => {
          setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        });
  }

    useEffect(() => {
       getSubPayments()
      setUserRole(userData.user.data.role.role_code.toLowerCase())
      
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);

const back = () => {
    navigate('/cashout'); 
  }
return (
<>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
      <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Create New Batch </h4>
      <div className="container" style={{backgroundColor: 'white'}}>
  
        <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
          <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <form onSubmit={addNewBatch}>
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px',}}>
                <div className="col-md-12" style={{padding: 0}}>
                  
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                 
                    <div className="form-group frm" style={{ position: 'relative' }}>
                    <FormField
                        type="number"
                        isRequierd = {true}
                        id="amount"
                        name="amount"
                        label="Max Amount"
                        onChange={handleChange}
                        placeholder = "Enter Max Amount"
                        error={errors.amount}
                        value = {formData.amount}
                        maxLength={20}
                      />
                        <i  onClick={clearAmount} class="fa fa-remove" style={{ top: '48px', position: 'absolute',right: '10px', 
                  color: '#666', cursor:'pointer'}} aria-hidden="true"></i>
                     
                  </div>
                
                    
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                    <SelectField 
                       id="searchTransaction"
                       isRequierd = {true}
                       name="payment_method"
                       label="Payment Method"
                       selectedField = "Select Payment Method"
                       value={formData.payment_method}
                       onChange={handleChange}
                       error={errors.payment_method}
                       options={paymentMethods}
                    />
                    </div>
                 
                   
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="submit" name="btn_admin_details" id="btn_basics_details" className="btn ddfg sebtn">Submit</button>
                  <button onClick={back} className="btn btn-success backbt sebtn" style={{'marginBottom':'0px'}}>Back</button>
                </div>
                <br />
              </div>
            </div>
            </form>
          </div>
         
        </div>
        {batchResponse && (
           <div className="card-batch">
           <table className="table-batch">
           <thead>
             <tr>
               <th>Batch ID</th>
               <th>Batch Code</th>
               <th>File</th>
             </tr>
           </thead>
           <tbody>
             <tr>
               <td>{batchResponse.batch_id}</td>
               <td>{batchResponse.batch_code}</td>
               <td>
                 <a href="#" onClick={downloadBatchFile}>Download</a>
               </td>
             </tr>
            
           </tbody>
           </table>
       </div>
        )}
       
<br /><br />

      </div>

     
      
    </div>
    </>
  );

}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(AddBatch));